import { IconFn, IconSvg } from "../createIcon";

export const EyeOffIcon: IconFn = ({ color = "#655C94", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 18, height: 16 }} {...props}>
    <path d="M11.241 7.526a2.06 2.06 0 0 0-.675-1.461A2.324 2.324 0 0 0 9 5.46l2.241 2.066Z" fill={color} />
    <path
      d="M7.38 4.104A4.15 4.15 0 0 1 9 3.765c1.074 0 2.104.402 2.864 1.117a3.702 3.702 0 0 1 1.186 2.695c-.001.45-.09.894-.261 1.313l2.511 2.194A11.917 11.917 0 0 0 18 7.577s-2.7-5.93-9-5.93a9.13 9.13 0 0 0-3.6.72l1.98 1.737ZM1.8.801l-.9.847L3.195 3.68A11.886 11.886 0 0 0 0 7.577s2.7 5.93 9 5.93a9.14 9.14 0 0 0 4.176-.983l3.024 2.677.9-.847L1.8.8ZM9 11.389a4.182 4.182 0 0 1-2.864-1.116A3.702 3.702 0 0 1 4.95 7.577a3.602 3.602 0 0 1 .54-1.863l1.377 1.22a1.981 1.981 0 0 0-.117.643c0 .345.088.685.259.99.17.305.419.565.721.76a2.37 2.37 0 0 0 2.089.216l1.386 1.228A4.207 4.207 0 0 1 9 11.389Z"
      fill={color}
    />
  </IconSvg>
);
